import {
    GET_ORDER_CHART,
    SET_ORDER_DROPDOWNS,
    SET_ORDER_DATA,
    SET_ORDER_LOADING,
    SET_ORDER_EXISTING_CLINS,
    SET_ORDER_LINE_FIELDS,
    SET_CLIN_COMMENTS,
    SET_REQUIRES_REASON_FOR_CHANGE
} from "../types";

const initialState = {
    chartData: {}, // contains chart data,
    data: {},
    view: {},
    dropdowns: {},
    loading: true,
    existing: { existing_clins: [], existing_clin_descriptions: [] },
    clin_comments: [],
    requires_reason_for_change: false,
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_ORDER_CHART:
            return {
                ...state,
                chartData: payload.types,
                chartLoading: false
            };
        case SET_ORDER_DROPDOWNS:
            return { ...state };
        case SET_ORDER_DATA: {
            return {
                ...state,
                ...payload,
                loading: false
            };
        }
        case SET_ORDER_LOADING:
            return {
                ...state,
                loading: payload
            };
        case SET_ORDER_EXISTING_CLINS:
            return {
                ...state,
                existing: payload
            };
        case SET_ORDER_LINE_FIELDS: {
            return {
                ...state,
                data: {
                    ...state.data,
                    products_and_services: payload
                }
            };
        }
        case SET_CLIN_COMMENTS: {
            return {
                ...state,
                clin_comments: payload
            };
        }
        case SET_REQUIRES_REASON_FOR_CHANGE: {
            return {
                ...state,
                requires_reason_for_change: payload
            };
        }
        default:
            return state;
    }
}

